<template>
    <div class="modalProgramCreateContainer">
        <div class="headerProgramCreate">
            <h2>{{IsEdit ? 'Editar Programas Académicos' : 'Seleccionar Programas Académicos'}}</h2>
            <p @click="closeCalendarCreateModal">X</p>
        </div>
        <div class="bodyProgramCreate">
            <div class="programCreateSelect">
                <label for="">Programa Académico</label>
                <select @change="addProgram" v-model="selectedElement">
                    <option value="" disabled ></option> 
                    <option v-for="program in programsData" :key="program.id_Program" :value="program.id_Program">{{ program.nam_Program }}</option>
                </select>
                <div v-if="showDuplicateNotification" class="notification">Ya agregó ese programa</div>
                <div v-if="showDataNotification" class="notification">Por favor agregue programas</div>
            </div>
            <ul class="programCreateList">
                <li v-for="(item, index) in programsSelected" :key="index"><a @click="deleteProgram(index)">{{ item }}</a></li>                
            </ul>
        </div>
        <div class="programButtonBefore">
            <button @click="switchFormOne">Anterior</button>
            <button v-if="IsEdit" @click="EditPrograms">Editar</button>
            <button v-else @click="AddPrograms">Guardar</button>
        </div>
    </div>
</template>
<script>
//Importa el componente de Vuex
import IberoHelpers from '@/store/helpers.js'

export default{
    props: {
        ProgramCreateDataByParent: Array,
        ProgramCreateDataObjectByParent: Array,
        IsEdit: Boolean,
    },
    data(){
        return{
            programsData: [],
            programsSelected: [],
            programsDataObject: [],
            selectedElement: null,
            showDuplicateNotification: false,
            showDataNotification: false,  
        }
    },
    methods: {
        //Método para poner en 0 las variables
        resetVariables(){
            this.programsData = [];
            this.programsSelected = [];
            this.programsDataObject = [];
            this.selectedElement = null;
            this.showDuplicateNotification = false;
            this.showDataNotification = false;
        },
        //Método para cerrar el modal
        closeCalendarCreateModal(){
            this.$emit('closeCalendarCreateModal');
            this.resetVariables();
        },
        //Método para cambiar al formulario de programas
        switchFormOne(){
            this.$emit('switchFormOne', this.programsSelected, this.programsDataObject);
        },
        //Método para cargar los programas en el select
        loadDataPrograms(){
            IberoHelpers.GetProgramsForCalendar(this.$store, 0)
                .then(response => {
                    this.programsData = response.data;
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });
            
            //Reciben información del padre si el usuario cambia de modal
            this.programsSelected = this.ProgramCreateDataByParent;
            this.programsDataObject = this.ProgramCreateDataObjectByParent;
        },
        //Método para añadir los programas a la lista y mostrarlos en pantalla. Adicionalmente se agregan al arreglo para hacer el insert de la tabla
        addProgram() {
            if (this.selectedElement) {
                // Buscar el programa por su id en la lista programsData
                const selectedProgram = this.programsData.find(program => program.id_Program === this.selectedElement);
            
                if (selectedProgram) {
                    // Verificar si el programa ya está en la lista programsSelected
                    const isAlreadyAdded = this.programsSelected.includes(selectedProgram.nam_Program);
                
                    if (!isAlreadyAdded) {
                        // Agregar el nombre del programa a la lista programsSelected
                        this.programsSelected.push(selectedProgram.nam_Program);
                        // Agregar el programa completo al arreglo programsDataObject
                        this.programsDataObject.push({
                            programa: selectedProgram.nam_Program,
                            codPrograma: selectedProgram.cod_Program,
                        });
                    }else {
                        // Mostrar la notificación si es un elemento duplicado
                        this.showDuplicateNotification = true;
                        setTimeout(() => {
                            this.showDuplicateNotification = false;
                        }, 3000);
                    }
                }
            
                this.selectedElement = null;
            }
        },
        //Método que valida que se hayan agregado programas y si es así hace la inserción
        AddPrograms(){
            if(this.programsSelected.length <= 0){
                // Mostrar la notificación si es un elemento duplicado
                this.showDataNotification = true;
                    setTimeout(() => {
                        this.showDataNotification = false;
                    }, 3000);
            }else{
                this.$emit('addCalendarPrograms');
            }
        },
        //Método que valida que se hayan agregado programas y si es así hace la edición
        EditPrograms(){
            if(this.programsSelected.length <= 0){
                // Mostrar la notificación si es un elemento duplicado
                this.showDataNotification = true;
                    setTimeout(() => {
                        this.showDataNotification = false;
                    }, 3000);
            }else{
                this.$emit('editCalendarPrograms');
            }
        },
        //Método para quitar programas de la lista
        deleteProgram(index){
            this.programsSelected.splice(index, 1);
            if (index >= 0 && index < this.programsDataObject.length) {
                this.programsDataObject.splice(index, 1);
            }
        }
    },
    mounted(){
        this.loadDataPrograms();
    }
}  
</script>
<style scoped>
    .programCreateList a{
        cursor: pointer;
    }
    .programCreateList li:hover{
        color: #d0ab4b;
    }
    .notification {
        background-color: #f2dede;
        border: 1px solid #ebccd1;
        border-radius: 4px;
        color: #a94442;
        font-size: 1rem;
        padding: 5px 10px;
        z-index: 1;
        animation: fadeIn 0.3s ease-in-out, fadeOut 0.3s ease-in-out 2.7s forwards;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes fadeOut {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
    .modalProgramCreateContainer{
        width: 80rem;
        height: 30rem;
        background-color: #fff;
        padding: 2rem;
    }
    .headerProgramCreate{
        display: flex;
        justify-content: space-between;
    }
    .headerProgramCreate h2{
        color: #d0ab4b;
        font-weight: bold;
        font-size: 1.5rem;
    }
    .headerProgramCreate p{
        color: #d0ab4b;
        font-weight: bold;
        font-size: 1.5rem;
        cursor: pointer;
    }
    .bodyProgramCreate{
        display: grid;
        grid-template-rows: repeat(2, 1fr); 
        text-align: center;
        height: 17rem;
        margin-bottom: 1rem;
    }
    .programCreateSelect{
        font-size: 1rem; 
    }
    .programCreateSelect label{
        margin-right: 1rem;
    }
    .programCreateList{
        font-size: 1rem;
        background-color: rgb(245, 248, 249);
        border-radius: 1rem;
        height: 13rem;
        overflow-y: auto;
        padding: 1rem;
    }

    .programButtonBefore{
        display: flex;
        justify-content: space-between;

    }
    .programButtonBefore button{
        background-color: #d0ab4b;
        color: white;
        border: none;
        font-size: 1rem;
        padding: 0.3rem 1rem;
        border-radius: 0.3rem;
    }
</style>